import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "col-12 mb-4 [ JS_shipment_select JS_shipment_scrollTo ]" };
const _hoisted_2 = {
    id: "RedLocalStorePayout",
    class: "col-12 bg-white border rounded pt-3 pb-2"
};
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-12" };
const _hoisted_5 = { class: "row py-3 pl-4" };
const _hoisted_6 = { class: "col-7 pr-0 custom-control custom-radio" };
const _hoisted_7 = { class: "row" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_radio_input = _resolveComponent("radio-input");
    const _component_locations_map_store_payout_selection = _resolveComponent("locations-map-store-payout-selection");
    const _component_location_store_selected = _resolveComponent("location-store-selected");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"row border-bottom\"><div class=\"col-12\"><div class=\"font7 mb-2\">Schritt 3 von 3</div></div><div class=\"col-7 pr-0\"><h2 class=\"h5 mb-3\">Wähle einen Store</h2></div><div class=\"col-5 text-right pl-0\"><span class=\"font7 p-1 bg-brand_green_neon rounded\">Kostenlos</span></div></div>", 1)),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_radio_input, {
                                id: "payoutLocalStore",
                                label: "Abgabe im Store vor Ort",
                                value: "1",
                                name: "vor-ort-auszahlung",
                                "tracking-class": "track_red_shipping_local_store",
                                checked: true
                            })
                        ]),
                        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-5 text-right" }, [
                            _createElementVNode("div", {
                                class: "border text-center float-right",
                                style: { "width": "72px", "max-width": "100%", "height": "30px", "object-fit": "contain", "border-radius": "8px" }
                            }, [
                                _createElementVNode("img", { src: "/images/_new_brand/icons_in_brand_design/icon_shop_checkout.svg" })
                            ])
                        ], -1))
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_7, [
                (!_ctx.selectedLocationId)
                    ? (_openBlock(), _createBlock(_component_locations_map_store_payout_selection, { key: 0 }))
                    : _createCommentVNode("", true),
                (_ctx.selectedLocationId)
                    ? (_openBlock(), _createBlock(_component_location_store_selected, {
                        key: 1,
                        storeId: _ctx.selectedLocationId,
                        onResetShopWasClicked: _ctx.resetShop
                    }, null, 8, ["storeId", "onResetShopWasClicked"]))
                    : _createCommentVNode("", true)
            ])
        ])
    ]));
}
